
import React, {useEffect} from "react";
import CourseInfoContainer from "../CourseInfoContainer";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {StepperModal} from "../../../Components/Fundamentals/Modal/StepperModal";
import BookEducationContainer from "../BookEducationContainer";
import useModal from "../../../Hooks/useModal";
import helpers from "../../../Utils/helpers";
import commonActionsImp from "../../../Actions/commonActions";
import {bindActionCreators} from "redux";
import customerActionsImp from "../../../Actions/customerActions";
import {
    StandardStepFooter,
    Step,
    StepBody,
    StepHeaderType
} from "../../../Components/Fundamentals/Stepper/Step";
import {Button, ButtonOption} from "../../../Components/Fundamentals/Button";

export default function EducationModal ( { eventId }) {
    const {t} = useTranslation();
    const { closeModal } = useModal();
    const dispatch = useDispatch();
    const bookEducationForm = useSelector((state) => state.CommonReducer.forms && state.CommonReducer.forms.bookEducation);
    const education = useSelector((state => state.CustomerReducer.selectedEducation));
    const customerActions = bindActionCreators(customerActionsImp, dispatch);
    const commonActions = bindActionCreators(commonActionsImp, dispatch);


    useEffect(() => {
        return () => {
            customerActions.clearSelectedCourse();
        }
    }, [])
    const onCancel = () => {
        if (bookEducationForm?.id)
            commonActions.cancelFormEditing(bookEducationForm.id);

        closeModal();
    }
    const onSubmit = () => {
        const finalisedForm = {
            ...bookEducationForm, data:
                {
                    ...bookEducationForm.data, course: education.name,
                    price: education.price,
                    date: helpers.formatDate(education.date),
                    location: education.location,
                }
        };

        customerActions.sendEducationBooking(finalisedForm, closeModal)
    }
    
    return <StepperModal title={t('editshortcutsmodal.bookeducation')} onClose={onCancel} stepHeaderType={StepHeaderType.NONE}>
            <Step>
                <StepBody>
                    <CourseInfoContainer eventId={eventId} />
                </StepBody>
            </Step>
            <Step>
                <StepBody>
                    <BookEducationContainer />
                </StepBody>
                <StandardStepFooter onCancel={onCancel}>
                    <Button onClick={onSubmit} option={ButtonOption.PRIMARY} disabled={!bookEducationForm?.data?.bookTerms} >{t('common.save')}</Button>
                </StandardStepFooter>
            </Step>
    </StepperModal>
}